export default {
    key: "third_party_error_log",
    id: "id",
    // type: "readonly",
    export: [],
    // excel: {
    //     //max_row: "50000"
    // },
    sort: {
        field: "id",
        order: "desc"
    },
    sort_fields: [
        "id",
        "rsrId",
        "action",
        "carparkId",
        "errorCode",
        "chargerId",
        "mallId",
        "memberId",
        "connectorId"
    ],
    options:[],
    filters:{
        id:{},
        rsrId:{},
        action:{},
        carparkId:{},
        errorCode:{},
        chargerId:{},
        mallId:{},
        memberId:{},
        connectorId:{}
    },
    action: ["pop-view"],
    fields:[
        {key :"id"},
        {key: "rsrId"},
        {key :"action"},
        {key :"carparkId"},
        {key :"memberId"},
        {key :"chargerId"},
        {key: "connectorId"},
        // {key :"connectorStatus"},
        {key :"errorCode"},
        {key :"mallId"},
        {key: "reason"},
        {key : "errorTime", type: "datetime", fill: false},
    ],
    view: {

    }

}